import React from "react";
import { Link } from "react-router-dom";
import { useApp, t } from "@/lib/AppContext";

export default function NotFound() {
  const { content } = useApp();
  return (
    <section className="min-h-[70vh] flex items-center" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="font-headings font-black text-[120px] md:text-[200px] leading-none" style={{ color: "var(--color-primary)", letterSpacing: "-0.05em" }}>404</div>
        <h1 className="font-headings font-extrabold text-2xl md:text-4xl mt-4">{t(content, "not_found.title", "Страница не найдена")}</h1>
        <p className="text-[var(--color-text-secondary)] mt-4 max-w-lg mx-auto">{t(content, "not_found.description", "")}</p>
        <Link to="/" className="btn-primary-cta mt-8 inline-flex">{t(content, "not_found.btn_home", "На главную")}</Link>
      </div>
    </section>
  );
}
